import React from 'react';

import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';

export const LoyaltyIcon = () => <LoyaltyPointsIcon />;
